import {
    CREATEZOOMSETTING,
    GETZOOMSETTING,
    UPDATEZOOMSETTING,
    DELETEZOOMSETTING,

} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEZOOMSETTING:
            return {
                ...state,
                zoomsettingSaveStatus: action.payload.success,
            }
        case GETZOOMSETTING:
                return {
                        ...state,
                        zoomList: action.payload.data,
                        }
        case UPDATEZOOMSETTING:
                return {
                        ...state,
                        zoomsettingUpdateStatus: action.payload.success,
                        }   

        case DELETEZOOMSETTING:
                return {
                     ...state,
                     zoomsettingDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                                  }
                             }